import React, { useState, useEffect } from 'react';
import Util from 'components/layout_and_quote_builder/quote_builder/Util.jsx';
import styles from 'components/layout_and_quote_builder/_style.module.scss';
import MyEventListener from 'components/common/MyEventListener.jsx'
import Constants from 'components/layout_and_quote_builder/Constants.jsx'
import LayoutSvgDownload from 'components/layout_and_quote_builder/quote_builder/LayoutSvgDownload.jsx'
import SolutionDimensions from 'components/layout_and_quote_builder/quote_builder/SolutionDimensions.jsx'
import PostRequest from 'components/common/PostRequest.jsx';

const LayoutSvg = ( { index, item, options, presentedOptions, navSection, selectedList, setSelectedList, multipleColumns} ) => {

  const _multipleColumns = true;
  const getSolution = () => {
    if(item == undefined)         { return }

    if(selectedList == undefined) { return }

    for(let i=0; i < selectedList.length; i++) {
      if(selectedList[i].diecutting_result.member.uuid == item.uuid) {
        return selectedList[i]
      }
    }
  }
  const [solution, setSolution] = useState( getSolution() )

  const handleClear = () => {
     PostRequest({
      url: `/layouts-nav-section-combinations/reset-selected-list/${window.user_quote_id}/${index}`,
      data: {
      },
      callback: (data) => {
        setSelectedList( () => [] )
        setSolution( () => undefined )
        if(data.page_reload) {
          location.reload(true)
        }
      }
    })

  }

  const downloadBtn = (type, format) => {
    let svgParams = getSvgPostParams(type)
    let defaultFileName = [ window.catalog_name, t(`layouts.download_type_${type}`)].join('-')
    if(index > 0) { defaultFileName = defaultFileName + "-" + `${index + 1}` }
    return <LayoutSvgDownload solution={solution} type={type} svgParams={svgParams} format={format} defaultFileName={defaultFileName} multipleColumns={_multipleColumns} />
  }

  const resetBtn = () => {
    if(window.user_quote_finalised) { return }
    return (
      <button className="btn btn-default" style={{"height" : "54px"}} onClick={handleClear} title={t('nav.back')} >
        <i className="zmdi zmdi-undo" onClick={handleClear}> </i>
         { !_multipleColumns && <>&nbsp; {t('nav.back')} </> }
      </button>
    )
  }

  const controlsForDieCut = () => {
      return (<table>
       <tbody>
        <tr>
          <th>
            {(downloadBtn('die_cutting', 'dxf'))} &nbsp;  &nbsp;
            {(downloadBtn('die_cutting', 'svg'))} &nbsp;  &nbsp;
            {(downloadBtn('die_cutting', 'pdf'))} &nbsp;  &nbsp;
            {resetBtn()}
          </th>
        </tr>
        </tbody>
    </table>)
  }

 const controlsForPrinting = () => {
      return (<table>
       <tbody>
        <tr>
           <th>
            {(downloadBtn('printing', 'dxf'))}  &nbsp;  &nbsp;
            {(downloadBtn('printing', 'svg'))}  &nbsp;  &nbsp;
            {(downloadBtn('printing', 'pdf'))}  &nbsp;  &nbsp;
            {resetBtn()}
           </th>
        </tr>
        </tbody>
    </table>)
  }

  const description_for = (layout_dimension) => {
    const { unit, locale } = window.user_quote;
    return layout_dimension[`description_${locale}_${unit}`];
  };


  const svgHeight = 380;

  const solutionSvg = () => {
    return <table className="table table-striped table-bordered">
      <tbody>
      <tr>
        <th> <center> <h4> {t('layouts.layout_type_die_cutting')}  </h4> </center> </th>
        <th> <center> <h4> {t('layouts.layout_type_printing')} </h4> </center> </th>
      </tr>

      <tr style={{ backgroundColor: 'black', height: svgHeight }}>
        <td> { showDiecuttingSvg() }  </td>
        <td> { showPrintingSvg() }   </td>
      </tr>

      <tr>
        <td> <center> <h4> { description_for(solution.diecutting_result.layout_dimension) }   </h4> </center> </td>
        <td> <center> <h4> { description_for(solution.diecutting_result.printing_result.layout_dimension) }  </h4>  </center>  </td>
      </tr>

      <tr>
        <td> <SolutionDimensions type="diecutting" solution={solution} /> </td>
        <td> <SolutionDimensions type="printing"  solution={solution} /> </td>
      </tr>

      <tr>
        <td> {controlsForDieCut()}  </td>
        <td> <div className="float-right"> {controlsForPrinting()}  </div> </td>
      </tr>
      </tbody>
    </table>
  }


  const theme = 'black_bg';
  const [dieCuttingSvg, setDieCuttingSvg] = useState('');
  const [printingSvg, setPrintingSvg] = useState('');

  const svgIdPrefix = () => {
    return item.is_item_extra ? item.extra_item_reason : "";
  }

  const IdFordieCuttingSvg = () => { return svgIdPrefix() + solution.diecutting_result.uuid + (_multipleColumns ? "_m" : "" ) ;}
  const IdForPrintingSvg =   () => { return svgIdPrefix() + IdFordieCuttingSvg() + [solution.diecutting_result.printing_result.num_x, solution.diecutting_result.printing_result.num_y, solution.diecutting_result.printing_result.l_shape ? "y" : "n"].join('_') }

  const getSvgPostParams = (type, svg_id) => {
    let data = solution;
    data.formula_options = window.dielineOptions;
    data.type = type;
    data.svg_id = svg_id;
    data.drawing_id = window.drawing_id;
    data.id         = window.drawing_id;
    data.layout_dimension_id = solution.material_layout_dimension.id;
    return data;
  }

  const fetchDiecuttingSvg = () => {
    if(solution == undefined) { setTimeout(fetchDiecuttingSvg, 250); return; }

    PostRequest({
      url: '/layouts_nav_section_combination_svg/',
      data: getSvgPostParams('die_cutting', IdFordieCuttingSvg()),
      callback: ( data ) => {
        setDieCuttingSvg( () => data.svg_content )
      }
    })

  }

  const fetchPrintingSvg = () => {
  if(solution == undefined) { setTimeout(fetchDiecuttingSvg, 250); return; }

    PostRequest({
      url: '/layouts_nav_section_combination_svg/',
      data: getSvgPostParams('printing', IdForPrintingSvg()),
      callback: ( data ) => {
        setPrintingSvg( () => data.svg_content )
      }
    })

  }

  const showDiecuttingSvg = () => {
    if(dieCuttingSvg == '') { return "" }

    return <div className={'redraw_theme_' + theme } dangerouslySetInnerHTML={{__html: dieCuttingSvg}}></div>

  }

  const showPrintingSvg = () => {
    if(printingSvg == '') { return "" }

    return <div className={'redraw_theme_' + theme } dangerouslySetInnerHTML={{__html: printingSvg}}></div>

  }

  const selectedListView = () => {
    return (<>
      { solutionSvg() }
    </>)
  }

  const onListen = (msg) => {
    if(msg.detail.index == index) {
      handleClear();
    }
  }

  const setupSvg = (id) => {
    if($(`#svg_${id}`).length == 0) { return; }
    $(`#layout_svg_${id}`).height(svgHeight);

    $(`#svg_${id}`).height(svgHeight);
    window.SVGControlsDisabled = true;

    setTimeout( () => {
      if($(`#svg_${id}`).length > 0) {
        performPanZoomInstance(`#svg_${id}`)
      }
    }, 200);
    setTimeout( () => { setupSvg(id) }, 500 )
  }

  // useEffect starts
  useEffect( () => {
    setSolution( () =>  getSolution() )
  }, [item] )

  useEffect( () => {
   console.log( { navSection } );
  }, [navSection] )

  useEffect(() => {
    setupSvg( IdFordieCuttingSvg() );
  }, [dieCuttingSvg]);

  useEffect(() => {
     setupSvg( IdForPrintingSvg() );
  }, [printingSvg]);

  useEffect(fetchDiecuttingSvg, [item])
  useEffect(fetchPrintingSvg, [item])

  useEffect( () => {
    if(solution == undefined) { return }
    emitEvent("quote_builder.solution_set", { index: index, solution: solution })
  }

  , [solution] )
  // useEffect ends
  MyEventListener([
    {
      key: Constants.layout_dimension_changed,
      callback: onListen
    }
  ])

  return (<>
    {selectedList.length > 0 && solution != undefined && selectedListView() }
  </>)
}

export default LayoutSvg;